function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { catchError, map, of } from 'rxjs';
import { SiteList } from '../config';
import { AppTypes, ClientNames, ClientQueryParams, InjectableServices } from '../enums';
import { SuperSubject } from '../models';
import { getClientPortalHost } from '../util';
import { getClientName } from '../util/get-client-name';
import { WindowedObservable } from '../windowed-observable';
import { BaseConfigService } from './base-config.service';
export var ClientService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(ClientService, BaseConfigService);
    function ClientService() {
        _class_call_check(this, ClientService);
        var _this;
        _this = _call_super(this, ClientService, arguments), _define_property(_this, "clientSettingSubject", new SuperSubject(null)), _define_property(_this, "clientSetting$", _this.clientSettingSubject.observable$), _define_property(_this, "clientNameSubject", new SuperSubject(null)), _define_property(_this, "clientName$", _this.clientNameSubject.observable$), _define_property(_this, "clientLoginTypeSubject", new SuperSubject(null)), _define_property(_this, "clientLoginType$", _this.clientLoginTypeSubject.observable$), _define_property(_this, "appTypeSubject", new SuperSubject(null)), _define_property(_this, "appType$", _this.appTypeSubject.observable$), _define_property(_this, "backDropLoadingSubject", new SuperSubject(false)), _define_property(_this, "backDropLoading$", _this.backDropLoadingSubject.observable$);
        return _this;
    }
    _create_class(ClientService, [
        {
            key: "backDropLoading",
            set: function set(v) {
                this.backDropLoadingSubject.value = v;
            }
        },
        {
            key: "resaveClientSettings",
            value: function resaveClientSettings() {
                // eslint-disable-next-line no-self-assign
                this.clientSettingSubject.value = this.clientSettingSubject.value;
            }
        },
        {
            key: "updateFavicon",
            value: function updateFavicon() {
                var _this = this;
                var $favicons = document.querySelectorAll('.favicon');
                if (!$favicons) return;
                var href = function(value) {
                    var _this_clientSettingSubject_value_common_logo, _this_clientSettingSubject, _this_clientSettingSubject1;
                    if (!_this.clientSettingSubject.value) return value;
                    var _this_clientSettingSubject_value_common_logo_assetClient;
                    var placeholder = (_this_clientSettingSubject_value_common_logo_assetClient = (_this_clientSettingSubject = _this.clientSettingSubject) === null || _this_clientSettingSubject === void 0 ? void 0 : (_this_clientSettingSubject_value_common_logo = _this_clientSettingSubject.value.common.logo) === null || _this_clientSettingSubject_value_common_logo === void 0 ? void 0 : _this_clientSettingSubject_value_common_logo.assetClient) !== null && _this_clientSettingSubject_value_common_logo_assetClient !== void 0 ? _this_clientSettingSubject_value_common_logo_assetClient : (_this_clientSettingSubject1 = _this.clientSettingSubject) === null || _this_clientSettingSubject1 === void 0 ? void 0 : _this_clientSettingSubject1.value.common.name;
                    return value.replace('placeholder', placeholder);
                };
                $favicons.forEach(function($favicon) {
                    var _$favicon_getAttribute;
                    $favicon.setAttribute('href', href((_$favicon_getAttribute = $favicon.getAttribute('href')) !== null && _$favicon_getAttribute !== void 0 ? _$favicon_getAttribute : ''));
                });
            }
        },
        {
            key: "getSettings",
            value: function getSettings(loginType) {
                var _this = this;
                var clientName = function() {
                    _this.appTypeSubject.value = loginType;
                    var clientPortalBase = getClientPortalHost();
                    if (loginType === AppTypes.auth) {
                        return clientPortalBase ? getClientName(clientPortalBase) : ClientNames.Procom;
                    }
                    return getClientName(window.location.hostname);
                };
                this.clientNameSubject.value = clientName();
                // Temporary way in switching profile view for sign up page
                var clientLoginType = function() {
                    if (_this.clientLoginTypeSubject.value) {
                        return _this.clientLoginTypeSubject.value;
                    }
                    var queryString = window.location.search;
                    var urlParams = new URLSearchParams(queryString);
                    return urlParams.get(ClientQueryParams.loginType);
                };
                this.clientLoginTypeSubject.value = clientLoginType();
                SiteList.find(function(portal) {
                    if (portal.name === _this.clientNameSubject.value) {
                        _this.clientSettingSubject.value = portal.settings;
                        _this.updateFavicon();
                        return true;
                    }
                    return false;
                });
            }
        },
        {
            key: "getTranslations",
            value: function getTranslations(clientCode, vendorCode) {
                var url = "".concat(this.environment.AUTH_API_URL, "/Translation/custom");
                return this.axios.post(url, {
                    clientCode: clientCode,
                    vendorCode: vendorCode
                }).pipe(map(function(response) {
                    var _response_data;
                    return (_response_data = response.data) !== null && _response_data !== void 0 ? _response_data : [];
                }), catchError(function() {
                    return of([]);
                }));
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.ClientService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new ClientService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return ClientService;
}(BaseConfigService);
